/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { WineClubDataStore } from '../../modules/wine-club-signup/wine-club-data';
import { AddressInputComponent } from './address-input';

export interface IAddressBillingCheckbox {
    isChecked: boolean;
    value: string;
    ariaLabel: string;
    text: string;
    wineState: boolean;
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

const AddressBillingCheckbox: React.FC<IAddressBillingCheckbox> = ({
    isChecked,
    value,
    ariaLabel,
    text,
    wineState,
    onChange
}) => {

    const additionalAttributes = {
        checked: isChecked,
        'aria-checked': isChecked,
    };

    const clubData = WineClubDataStore.getInstance().get();
    let shouldShowCheckbox = true;
    if (clubData.deliveryType === 'PICKUP' && wineState) {
        shouldShowCheckbox = false;
    }

    return (
        <label className='ms-checkout-billing-address__shipping-address-label'>
            {
                shouldShowCheckbox && <AddressInputComponent {...{ type: 'checkbox', className: 'ms-checkout-billing-address', value: value, onChange: onChange, additionalAddributes: additionalAttributes }} />
            }
            <span className='ms-checkout-billing-address__shipping-address-checkbox-text'>
                {text}
            </span>
        </label>
    );
};

export default AddressBillingCheckbox;
